module.exports = __webpack_public_path__ + "static/img/card-solution.dd881ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-solution.png
// module id = WbYQ
// module chunks = 34